export const GET_WORK_WITH_US_REQUEST = "GET_WORK_WITH_US_REQUEST";
export const GET_WORK_WITH_US_SUCCESS = "GET_WORK_WITH_US_SUCCESS";
export const GET_WORK_WITH_US_FAIL = "GET_WORK_WITH_US_FAIL";
export const GET_WORK_WITH_US_RESET = "GET_WORK_WITH_US_RESET";

export const PUT_WORK_WITH_US_REQUEST = "PUT_WORK_WITH_US_REQUEST";
export const PUT_WORK_WITH_US_SUCCESS = "PUT_WORK_WITH_US_SUCCESS";
export const PUT_WORK_WITH_US_FAIL = "PUT_WORK_WITH_US_FAIL";
export const PUT_WORK_WITH_US_RESET = "PUT_WORK_WITH_US_RESET";
